import { useSelector } from 'react-redux';
import { useLocation, generatePath, useParams } from 'react-router-dom';
import FullPageLoader from '../../components/UIElements/Loader/fullPageLoader';
import {
  getCompletePathList,
  getDefaultAuthRoute,
} from '../../routes/index.routes';
import {
  AuthDriver as authDriver,
  getLocalStorageToken,
  userRoleCheck,
} from '../../utils';
function AppLayout({ children }) {
  const location = useLocation();
  const params = useParams();
  const user = useSelector((state) => state?.auth?.storeData);

  const storeToken = getLocalStorageToken('store');

  const activeRoute = getCompletePathList().find((e) => {
    const routePath = getGeneratedPath(e.path);
    const browserPath = window.location.pathname;
    return routePath === browserPath;
  });

  function getGeneratedPath(path) {
    try {
      return generatePath(path, params);
    } catch (error) {
      return path;
    }
  }

  // const activeRoute = getCompletePathList().find(e => e.key === location.pathname);
  // const activeRoute = getCompletePathList().find(e => e.key.search(location.pathname.replace(/[0-9]/g, '')) >=0)
  // const isPrivate = activeRoute?.private;
  // const isValid = authDriver(activeRoute);
  const isValid = authDriver(
    activeRoute,
    userRoleCheck(user?.Role),
    location.pathname.split('/')?.[1],
    false,
    'storeLayout'
  );

  if (!isValid) {
    window.location = getDefaultAuthRoute(
      userRoleCheck(user?.Role) || 'store',
      // user?.token
      storeToken
    );
  } else {
    return children;
  }
  return <FullPageLoader />;
}

export default AppLayout;
